import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { PhoneNumberUtil } from "google-libphonenumber";

export class HelperMethods {

    public uppercaseValidator(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: { message: string } } | null => {
            if (!(/[A-Z]/.test(control.value))) {
                return {
                    reqUppercase: {
                        message: `One upper case letter`
                    }
                };
            }
            return null;
        };
    }

    public lowercaseValidator(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: { message: string } } | null => {
            if (!(/[a-z]/.test(control.value))) {
                return {
                    reqLowercase: {
                        message: `One lower case letter`
                    }
                };
            }
            return null;
        };
    }

    public numberValidator(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: { message: string } } | null => {
            if (!(/\d+/.test(control.value))) {
                return {
                    reqNumber: {
                        message: `One number`
                    }
                };
            }
            return null;
        };
    }

    public SpecialCharValidator(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: { message: string } } | null => {
            const regx = /[$#-/:-?{-~!"^_@`\[\]]/g;
            if (!regx.test(control.value)) {
                return {
                    reqSpecialChar: {
                        message: `One special character`
                    }
                };
            }
            return null;
        };
    }

    public PhoneNumberValidator(): ValidatorFn {
        const phoneUtil = PhoneNumberUtil.getInstance();
        return (control: AbstractControl): ValidationErrors | null => {
          if (!control.value) {
            return null;
          }
      
          try {
            const parsedNumber = phoneUtil.parseAndKeepRawInput(control.value);
            const isValid = phoneUtil.isValidNumber(parsedNumber);
            return isValid ? null : { invalidPhoneNumber: true };
          } catch (error) {
            return { invalidPhoneNumber: true };
          }
        };
      }
}